import { defineStore } from 'pinia'

import { StoreState } from '@shared/models/interfaces/store'
import { resourcePath } from '@shared/plugins/api'
import { ApiTransport } from '@shared/plugins/api-transport'
import {
  getInitialState,
  updateState,
} from '@shared/utils/store/http-request-state'

import { Show as CollectedInfoDTO } from '@protos/apps/pc/request/collected_info/show_pb'
import { Show as QuickFormShowDTO } from '@protos/apps/pc/request/quick_form/show_pb'
import { Item as CollectedInfoRO } from '@protos/apps/pc/response/collected_info/item_pb'
import { Item as QuickFormItemRO } from '@protos/apps/pc/response/quick_form/item_pb'
import { QuickForm } from '@protos/chat/quick_form_pb'

import { PlainMessage } from '@bufbuild/protobuf'

interface State {
  quickForm: StoreState<PlainMessage<QuickForm>>
  quickFormMap: Record<string, StoreState<PlainMessage<QuickForm>>>
}

const state = (): State => ({
  quickForm: getInitialState(),
  quickFormMap: {},
})

const apiTransport = new ApiTransport(resourcePath, 'pc')

export const useQuickFormsStore = defineStore('quick-forms', {
  state,

  actions: {
    async fetchQuickFormById(dto: PlainMessage<QuickFormShowDTO>) {
      if (dto.id.case === 'quickFormUuid' && dto.id.value) {
        this.quickFormMap[dto.id.value] = updateState(
          this.quickFormMap[dto.id.value]
        )
      }

      this.quickForm = updateState(this.quickForm)

      try {
        const response = await apiTransport.get(
          '/quick_forms',
          new QuickFormShowDTO(dto),
          QuickFormItemRO
        )

        const { data } = response

        this.quickForm = updateState(this.quickForm, data)
        if (dto.id.case === 'quickFormUuid' && dto.id.value) {
          this.quickFormMap[dto.id.value] = updateState(
            this.quickFormMap[dto.id.value],
            data
          )
        }
        return data!
      } catch (e) {
        if (dto.id.case === 'quickFormUuid' && dto.id.value) {
          this.quickFormMap[dto.id.value] = updateState(
            this.quickFormMap[dto.id.value],
            e as Error
          )
        }
        this.quickForm = updateState(this.quickForm, e as Error)
        throw e
      }
    },
    async fetchCollectedInfo(dto: PlainMessage<CollectedInfoDTO>) {
      const data = await apiTransport.get(
        '/collected_info',
        new CollectedInfoDTO(dto),
        CollectedInfoRO
      )

      return data.data!
    },
  },

  getters: {
    getQuickFormByUuid: (state) => (uuid?: string) => {
      return uuid ? state.quickFormMap[uuid] : undefined
    },
  },
})
